var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98552 16.4986C9.72414 16.4986 10.3238 17.1067 10.3238 17.8558C10.3238 18.6048 9.72414 19.2129 8.98552 19.2129C8.24691 19.2129 7.64726 18.6048 7.64726 17.8558C7.64726 17.1067 8.24691 16.4986 8.98552 16.4986ZM18.7994 16.4986C19.5381 16.4986 20.1377 17.1067 20.1377 17.8558C20.1377 18.6048 19.5381 19.2129 18.7994 19.2129C18.0608 19.2129 17.4612 18.6048 17.4612 17.8558C17.4612 17.1067 18.0608 16.4986 18.7994 16.4986ZM5.57283 3.87347L4.95091 0.927593C4.86268 0.510559 4.49964 0.212891 4.07846 0.212891H1.40194C0.90945 0.212891 0.509766 0.618209 0.509766 1.11764C0.509766 1.61708 0.90945 2.02239 1.40194 2.02239H3.35754L5.73153 13.2584C5.90738 14.0927 6.63447 14.6888 7.47586 14.6888H20.2982C21.1493 14.6888 21.881 14.0799 22.0479 13.2339L23.4754 5.9985C23.5797 5.46635 23.4441 4.9146 23.1042 4.49475C22.7642 4.07589 22.2566 3.83236 21.7213 3.83417L5.57283 3.87347ZM21.7258 5.64399L5.9557 5.68216L7.47597 12.8793H20.2983L21.7258 5.6439V5.64399Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNew);
export default __webpack_public_path__ + "static/media/cart-new.fc5736ac4fb422c50b37d88878252745.svg";
export { ForwardRef as ReactComponent };